module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Chaise_Sand.871dcd86.png";